import React from "react";
import {
  formatUTCDate_dmy,
  getImageUrl
} from "../../../../MIS/Global";
import {
  calcSubTotal,
  getAddonNameById,
  getType
} from "../../../../API/Model/quotaionModel";
import "./PrintViewResponsive.css";
import invoiceLogo from '../../../../Assets/vLogo.png';
import { convertAmountToWords } from "../../../../MIS/amountToWords";

const PrintView = ({ quote = {}, addons }) => {
  const quoteDetail = quote;

  return (
    <div className="bill-wrapper">
      {/* Header */}
      <div className="bill-header text-center">
        <h1 className="bill-title">INVOICE</h1>
      </div>

      {/* Company Details */}
      <div className='bill-section1 mobile-only bill-divider'>
        <div style={{textAlign:'center',width:'100%'}}><strong>Tee Blanka</strong></div>
        <div style={{textAlign:'center',width:'100%'}}>B-9, Yashsvi Chembers, Near Bank Of Baroda Opp.Sarda Brothers Sangli Maharashtra 416416</div>
        <div style={{textAlign:'center',width:'100%'}}>Phone: +91-93722 12822</div>
      </div>
      <div className="bill-details bill-divider desktop-only">
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', width: '100%' }}>
          <div>
            <img
              src={invoiceLogo}
              alt="Logo"
              className="logo-image"              
            />
          </div>
          <div className="bill-section1" style={{ flex: 1 }}>
            <span><strong>Tee Blanka</strong></span>
            <span className='wrapped-address'>
              B-9, Yashsvi Chembers, Near Bank Of Baroda Opp.Sarda Brothers Sangli Maharashtra 416416
            </span>
            <span>Phone: +91-93722 12822</span>
            <span>Email: teeblanka2024@gmail.com</span>
            <span>Website: www.teeblanka.com</span>
          </div>
          <div className="bill-divider-vertically"></div>
          <div className="bill-section1" style={{ flex: 1 }}>
            <div className="bill-section-sub">
              <span>Invoice #: <strong>{quoteDetail.quote_no}</strong></span>
              <span>Invoice date: <strong>{formatUTCDate_dmy(quoteDetail.quote_date)}</strong></span>
            </div>
            <div className="bill-section-sub">
              <span>Type: <strong>{quoteDetail.quote_type !== 0 ? getType(quoteDetail.quote_type) : '-'}</strong></span>
              <span>Delivery date: <strong>{formatUTCDate_dmy(quoteDetail.quote_date)}</strong></span>
            </div>
            <span>Cloth: <strong>{quoteDetail.cloth_name}</strong></span>
          </div>
        </div>
      </div>

      {/* Party Details */}
      <div className="bill-details-row">
        <div className="bill-party-info">
          <span><strong>Bill To:</strong> {quoteDetail?.shop_name || "N/A"}</span>
          <span>{quoteDetail?.party_address},{quoteDetail?.party_city}, {quoteDetail?.party_state} - {quoteDetail?.party_pinCode}</span>
          <span><strong>Contact:</strong> {quoteDetail?.party_name}, {quoteDetail?.party_mob}</span>
          <div className="bill-divider mobile-only" style={{marginBottom:0,paddingTop:'5px',paddingBottom:'5px'}}></div>
          <span className='mobile-only'><strong>Ivoice #:</strong> {quoteDetail.quote_no}</span>
          <span className='mobile-only'>Date: {formatUTCDate_dmy(quoteDetail.quote_date)}</span>
          <span className='mobile-only'>Cloth: {quoteDetail.cloth_name}</span>
          <span className='mobile-only'>Expected: {formatUTCDate_dmy(quoteDetail.quote_date)}</span>
        </div>

        <div className="bill-image-fill">
          {quoteDetail.product_image && (
            <img
              src={getImageUrl(`${quoteDetail.product_image}`)}
              alt="Product"
              className="product-image-fill"
            />
          )}
        </div>
      </div>

      {/* Items Table */}
      <table className="bill-table">
        <thead>
          <tr>
            <th>Particular</th>
            <th>Size</th>
            <th>Qty</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {quoteDetail.details?.map((item, idx) => (
            <tr key={idx}>
              <td>{item.item_name}</td>
              <td>{item.item_size}</td>
              <td>{item.item_qty}</td>
              <td>{item.item_rate.toLocaleString()}</td>
              <td style={{ textAlign: 'end' }}>{item.item_amount.toLocaleString()}</td>
            </tr>
          ))}
          {quoteDetail.addons?.map((item, idx) => (
            <tr key={`addon-${idx}`}>
              <td>{getAddonNameById({ addons_id: item?.addons_id, addons })}</td>
              <td>Addon</td>
              <td>{item?.addon_qty}</td>
              <td>{Number(item?.addon_rate).toFixed(2)}</td>
              <td style={{ textAlign: 'end' }}>{Number(item?.addons_amount).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div className="bill-totals">
        <div className="totals-line">
          <span>Subtotal:</span>
          <span>₹{Number(calcSubTotal(quoteDetail?.sub_total, quoteDetail?.addons_total)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
        </div>
        {quoteDetail?.quote_type > 0 && (
          <div className="totals-line">
            <span>Addons:</span>
            <span>₹{Number(quoteDetail?.addons_total || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
          </div>
        )}
        {quoteDetail?.s_gst > 0 && (
          <div className="totals-line">
            <span>CGST:</span>
            <span>₹{Number(quoteDetail?.s_gst).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
          </div>
        )}
        {quoteDetail?.c_gst > 0 && (
          <div className="totals-line">
            <span>SGST:</span>
            <span>₹{Number(quoteDetail?.c_gst).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
          </div>
        )}
        <div className="totals-line total-grand">
          <span>Grand Total:</span>
          <span>₹{Number(quoteDetail?.grand_total).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
        </div>
      </div>

      {/* Footer */}
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderTop: '1px solid #ccc', paddingTop: '8px' }}>
        <div className="bill-section1">
          <div><span>Words: <strong>{convertAmountToWords(quoteDetail?.grand_total)}</strong></span></div>
          <span>Terms & Conditions:</span>
          <span>1. Our responsibility ceases as soon as goods leave our premises. </span>
          <span>2. Goods once sold cannot be taken back or exchanged.</span>
          <span>3. Interest @24% p.a. will be charged on this bill, if not paid as per bill terms.</span>
          <span>4. All disputes subject to Sangli Jurisdiction.</span>
        </div>
        <div className="bill-section1 text-right">
          <span>A/c Name: Tee Blanka</span>
          <span>Bank Name: ICICI BANK</span>
          <span>A/c No.: 777705666002</span>
          <span>Branch: INAM DHAMANI BRANCH</span>
          <span>IFSC: ICIC0006386</span>
        </div>
      </div>
    </div>
  );
};

export default PrintView;
